import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IFormPosterProps extends IBaseElementProps {
	image?: IImage;
	excerpt?: string;
}

/**
 * FormPoster
 * @block
 * @icon list-view
 */
const FormPoster: React.FC<IFormPosterProps> = ({ id, image, excerpt }) => {
	return (
		<div
			id={id}
			className={cn(
				'form-poster',
				'py-7',
				'py-lg-9',
				'ps-lg-8',
				'ps-md-5',
				'ps-3',
				'h-100',
				'w-100',
				'd-flex',
			)}
		>
			<div
				className={cn(
					'form-poster--content',
					'd-flex',
					'flex-lg-column',
					'flex-column-reverse',
					'justify-content-center',
					'w-100',
				)}
			>
				{image && (
					<Image className={cn('w-100', 'h-auto')} {...image} />
				)}
				{excerpt && (
					<div
						className={cn(
							'form-poster--excerpt',
							'pe-lg-8',
							'pe-md-5',
							'pe-3',
						)}
					>
						<p className="lead text-white mb-0">{excerpt}</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default FormPoster;
